import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * BackToTop, floating round button that appears after the user has scrolled
 * past `threshold` pixels. Clicking smooth-scrolls to the top.
 */
export default function BackToTop({ threshold = 480 }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      data-testid="back-to-top"
      className={`fixed right-5 md:right-8 bottom-24 z-[60] w-12 h-12 rounded-full bg-[#1C3E5F] text-[#B8965A] border border-[#B8965A]/40 shadow-xl hover:bg-[#B8965A] hover:text-[#12283F] transition-all duration-300 flex items-center justify-center ${
        show ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ArrowUp size={18} strokeWidth={2.5} />
    </button>
  );
}
